import Vue from 'vue'
import VueRouter from 'vue-router'
import ls from 'local-storage'
import store from '@/store'
import {fetchAccessToken, fetchFeishuLogin} from '@/assets/js/commonApi';
import {MessageBox, Loading} from 'element-ui';

// import userRouter from './modules/user'; //用户管理路由
// import systemRouter from './modules/system'; //系统管理路由
// import liveRouter from './modules/live'; //直播路由
// import opinionRouter from './modules/opinion'; //舆情管理路由
// import operationRouter from './modules/operation';//运营管理路由
// import msgPushRouter from './modules/msgPushManage'; // 消息推送管理
// import goodsManageRouter from './modules/goodsManage'; // 商品管理
// import promotionRouter from './modules/promotion';//促销管理路由
// import raiseRouter from './modules/raise';//众筹管理路由
// import activityRouter from './modules/activityManage';//演出管理路由
// import workbenchRouter from './modules/workbench'; //工作台路由管理
// import financeRouter from './modules/finance'; //财务管理路由
import modules from './modules'

Vue.use(VueRouter)

const routes = [{
    path: '/login',
    name: 'login',
    component: () => import('@/views/passport/login'),
    meta: {
        requireAuth: false
    }
}, {
    path: '/',
    component: () => import('@/layout'),
    redirect: '/index',
    meta: {
        requireAuth: true
    },
    children: [
        {
            path: 'index',
            name: 'index',
            component: () => import('@/views/index'),
            meta: {
                breadcrumb: false
            }
        },
        {
            path: '404',
            name: '404',
            component: () => import('@/views/error/404'),
            meta: {
                breadcrumb: false
            }
        },
        // {
        //     path: 'dashboard',
        //     name: 'dashboard',
        //     component: () => import('@/views/dashboard'),
        //     meta: {
        //         title: "Dashboard"
        //     }
        // },
        ...modules,
    ]
},
{path: '*', redirect: '/404', meta: {breadcrumb: false}}]

// 使用push()、replace()进行导航时，不能重复导航到当前路由。
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
    mode: 'history',
    scrollBehavior: () => ({x: 0, y: 0}),
    routes
})

//登录拦截
router.beforeEach(async(to, from, next) => {
    const _accessToken = store.state.accessToken;
    if(!_accessToken){
        const loading = Loading.service({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        const res = await fetchAccessToken();
        loading.close();
        const {result,msg} = res.data;
        
        if( !result ){
            MessageBox.confirm(msg || '请求失败请重试', '提示', {
                confirmButtonText: '立即刷新',
                showCancelButton: false,
                showClose: false,
                closeOnClickModal: false,
                closeOnPressEscape:false,
                center: true
            }).then(() => {
                window.location.reload();
            }).catch(() => {});
            return;
        }
    }
    
    const _sign = ls.get('CUSUT');

    if (to.matched.some(r => r.meta.requireAuth)) {
        if (to.path === '/login') return next()
        if (_sign) {
            // const userInfo = cookie.get('userInfo');
            // const menuList = cookie.get('menuList');
            // if( !userInfo ){
            //     getUserInfo();
            // }
            // if(!menuList){
            //     getMenuList();
            // }
            if( !store.state.CUSUT ){
                store.commit( 'setCUSUT', _sign );
            }
            next();
            
        } else {
            const loading = Loading.service({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const res = await fetchFeishuLogin();
            loading.close();

            const { state, result } = res.data;
            if (state && result ){
                next();
            }else{
                next({
                    path: '/login',
                    query: {
                        redirect: to.fullPath
                    }
                })
            }
        }
    } else {
        next()
    }
    store.commit( 'setDebug', to.query.debug );
})

//异常处理
router.onError(async error => {
    if (error.toString().indexOf('ChunkLoadError') === -1) {
        return;
    }

    const flag = await MessageBox.confirm('服务器版本已经更新，页面刷新后可以恢复正常使用', '提示', {
        confirmButtonText: '立即刷新',
        cancelButtonText: '取消',
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape:false,
        center: true
    }).catch(() => 'cancel');

    if (flag === 'cancel') {
        return;
    }

    window.location.reload();
})

export default router